import { Routes, Route } from "react-router-dom";
import AppShell from "./layout/AppShell";
import About from "./Pages/About";
import Experience from "./Pages/Experience";
import Projects from "./Pages/Projects";
import ProjectDetail from "./Pages/ProjectDetail";
import Writing from "./Pages/Writing";

function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<About />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:slug" element={<ProjectDetail />} />
        <Route path="/writing" element={<Writing />} />
      </Route>
    </Routes>
  );
}

export default App;
